<app-stages [stages]="stages" currentStage="Lokalizacja">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <fieldset>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-0 mt-3">
            <div class="custom-radio custom-inline">
              <input (change)="form.provideRoadNumberAndNameChange(true)" name="provideRoadNumberAndName"
                     formControlName="provideRoadNumberAndName" type="radio"
                     id="provideRoadNumberAndNameTrue" [value]="true">
              <label for="provideRoadNumberAndNameTrue">
                Chcę wprowadzić numer i nazwę drogi
              </label>
            </div>
            <div class="custom-radio custom-inline">
              <input (change)="form.provideRoadNumberAndNameChange(false)" name="provideRoadNumberAndName"
                     formControlName="provideRoadNumberAndName" type="radio"
                     id="provideRoadNumberAndNameFalse" [value]="false">
              <label for="provideRoadNumberAndNameFalse">
                Chcę wprowadzić ulicę i numer budynku
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class='row'>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"city" as controlName'>
            <label [for]='controlName'>
              Miejscowość *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              (change)="form.cityChange()"
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @if (form.provideRoadNumberAndName.value) {
                @for (item of form.townWithRoadsList(); track $index) {
                  <option [value]='item.name'>{{ item.name }}</option>
                }
              } @else {
                @for (item of form.townWithStreetsList(); track $index) {
                  <option [value]='item.name'>{{ item.name }}</option>
                }
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.roadNumber) {
          <div class='col-md-3'>
            <div class='form-group' *ngIf='"roadNumber" as controlName'>
              <label [for]='controlName'>
                Numer drogi *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                (change)="form.roadNumberChange(form.getElement($event).value)"
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                @for (item of form.getRoadList(form.city.value); track $index) {
                  <option [value]='item.roadNumber'>{{ item.roadNumber }}</option>
                }
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.roadName) {
          <div class='col-md-5'>
            <div class='form-group' *ngIf='"roadName" as controlName'>
              <label [for]='controlName'>
                Nazwa drogi *
              </label>
              <input
                readonly
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwę drogi'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.street) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"street" as controlName'>
              <label [for]='controlName'>
                Ulica *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                @for (item of form.getStreetList(form.city.value); track $index) {
                  <option [value]='item.roadNumber + " - " + item.name'>{{ item.roadNumber + " - " + item.name }}
                  </option>
                }
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.houseNumber) {
          <div class='col-md-2'>
            <div class='form-group' *ngIf='"houseNumber" as controlName'>
              <label [for]='controlName'>
                Nr budynku
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu numer budynku'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
    </fieldset>
    <app-exposed-map-control [control]="form.geometry"></app-exposed-map-control>
    <br>
    <fieldset>
      <legend>
        Działki
      </legend>
      <div class="row">
        <div class="col-12">
          <app-parcels-crud formControlName="parcels"></app-parcels-crud>
        </div>
      </div>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
